import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MegaMenu extends Component {
     constructor(props) {
          super();

     }


     MenuItemClick = (event) => {
          //event.target.classList.toggle("active") কোডটি বাটনে active ক্লাস যোগ বা সরায়
          //panel ভেরিয়েবলটি event.target.nextElementSibling এর মাধ্যমে বাটনের পরবর্তী div.panel উপাদানটি ধরে রাখে।
          //scrollHeight হল একটি এইচটিএমএল এলিমেন্টের ভেতরের পুরো কন্টেন্টের উচ্চতা, যাতে স্ক্রলবার থাকলেও সব কন্টেন্ট দেখা যায়।
          //panel.scrollHeight শুধু একটি সংখ্যাসূচক মান দেয় (যেমন, 300),
          //"px" যোগ করে, কোডটি এই মানটি পিক্সেল ইউনিটে রূপান্তর করে (300px)
          //যখন panel.style.maxHeight = panel.scrollHeight + "px" সেট করা হয়, তখন প্যানেলের maxHeight সিএসএস প্রপার্টি সেট করা হয় 
          //প্যানেলের পূর্ণ উচ্চতায়, ফলে সম্পূর্ণ কন্টেন্ট দৃশ্যমান হয়।
          //যদি maxHeight আবার null করা হয়, তখন প্যানেল বন্ধ হয়ে যায়।
          event.target.classList.toggle("active");
          var panel = event.target.nextElementSibling;
          if (panel.style.maxHeight) {
               panel.style.maxHeight = null;
          } else {
               panel.style.maxHeight = panel.scrollHeight + "px"
          }

     }



     render() {

          const CatList = this.props.data;

          //CatList.map() হল একটি অ্যারে মেথড, যা CatList অ্যারের প্রতিটি উপাদানের উপর একটি ফাংশন প্রয়োগ করে এবং একটি নতুন অ্যারে রিটার্ন করে।
          //এখানে CatList এর প্রতিটি উপাদানকে CatList ভেরিয়েবল হিসাবে ব্যবহার করা হয়েছে, এবং i ব্যবহার করা হয়েছে প্রতিটি উপাদানের ইন্ডেক্স হিসেবে।
          //return <div key={i.toString()}>, এখানে return স্টেটমেন্টটি প্রতিটি ক্যাটাগরির জন্য একটি <div> উপাদান তৈরি করে রিটার্ন করছে।
          //<div key={i.toString()}> এর key প্রপার্টি React এ ব্যবহার হয় প্রতিটি উপাদানকে ইউনিকভাবে চিহ্নিত করতে। i.toString() ইন্ডেক্সকে স্ট্রিংয়ে রূপান্তর করে, 
          //যা key হিসেবে ব্যবহার করা হয়েছে।
          //CatList.subcategory_name).map((SubList, i)
          //প্রতিটি ক্যাটাগরির মধ্যে CatList.subcategory_name অ্যারের উপর map() প্রয়োগ করা হয়েছে।
          //এই map() ফাংশন প্রতিটি সাব-ক্যাটাগরির জন্য কাজ করে।
          //SubList হলো প্রত্যেকটি সাব-ক্যাটাগরির তথ্য ধারণকারী ভেরিয়েবল, এবং i হলো তার ইন্ডেক্স।
          //এই লুপের মাধ্যমে প্রতিটি সাব-ক্যাটাগরির জন্য একটি <li> উপাদান এবং একটি <Link> তৈরি করা হচ্ছে, যা সাব-ক্যাটাগরি নাম (SubList.subcategory_name) হিসেবে রেন্ডার হয় 
          //এবং একটি রাউটিং লিংক তৈরি করে।

          const MyView = CatList.map((CatList, i) => {
               return <div key={i.toString()}>
                    <button onClick={this.MenuItemClick} className="accordion">
                         <img className="accordionMenuIcon" src={CatList.category_image} />&nbsp; {CatList.category_name}
                    </button>
                    <div className="panel">
                         <ul>
                              {
                                   (CatList.subcategory_name).map((SubList, i) => {
                                        return <li><Link to={"productsubcategory/" + CatList.category_name + "/" + SubList.subcategory_name} className="accordionItem" >{SubList.subcategory_name} </Link></li>

                                   })
                              }

                         </ul>
                    </div>

               </div>



          });





          return (
               <div className="accordionMenuDiv">
                    <div className="accordionMenuDivInside">

                         {MyView}

                    </div>

               </div>
          )
     }
}

export default MegaMenu;
